import { type Dispatch, type SetStateAction, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import * as tradeInSelectors from '@makemydeal/dr-dash-store/selectors/trade';

import LienholderFormHeader from './LienholderFormHeader.interstate';
import LienholderFormInputs from './LienholderFormInputs.interstate';

import type { LienholderFormData, SoftSaveLienHolderData } from '../../../types';
import { getLienholderFormData } from './utils';
import { StyledLienholderFormContainer } from './LienholderForm.interstate.style';

export interface LienholderFormProps {
    isEditDisabled: boolean;
    lienholderData: LienholderFormData;
    setLienholderData: Dispatch<SetStateAction<LienholderFormData>>;
    softSaveLienHolderData?: SoftSaveLienHolderData;
}

const LienholderForm = ({ isEditDisabled, lienholderData, setLienholderData, softSaveLienHolderData }: LienholderFormProps) => {
    const sourceLienholderData = useSelector(tradeInSelectors.getLienholderFull);

    const prevSourceLienholderData = useRef(sourceLienholderData);

    useEffect(() => {
        const isEqual = JSON.stringify(sourceLienholderData) === JSON.stringify(prevSourceLienholderData.current);
        if (!isEqual) {
            setLienholderData(getLienholderFormData(sourceLienholderData));
        }
        prevSourceLienholderData.current = sourceLienholderData;
    }, [sourceLienholderData]);

    return (
        <StyledLienholderFormContainer>
            <LienholderFormHeader />
            {
                <>
                    <LienholderFormInputs
                        isTradeInCompleted={true}
                        lienholderData={lienholderData}
                        setLienholderData={setLienholderData}
                        softSaveLienHolderData={softSaveLienHolderData}
                        isEditDisabled={isEditDisabled}
                    />
                </>
            }
        </StyledLienholderFormContainer>
    );
};

export default LienholderForm;
